var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-outline alpha-success border-success-600 legitRipple",attrs:{"type":"button"},on:{"click":_vm.clicked}},[_c('i',{staticClass:"icon-reload-alt mr-2"}),_vm._v(" "+_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }